<template>
  <v-progress-circular v-if="loading" indeterminate color="primary">
  </v-progress-circular>
  <div v-else v-html="content"></div>
</template>

<script>
import { mapActions } from "vuex";
import { mapFields } from 'vuex-map-fields';

export default {
  name: "LegalContract",
  props: {
    params: {
      type: Object,
      required: false,
      default: () => ({})
    },
    kind: String,
    api: {
      type: String,
      required: false,
      default: "get_lastest_legal_contract"
    },
  },
  async mounted() {
    this.init({ params: this.params, api: this.api, kind: this.kind }).then((response) => {
      this.$emit('contract-data', response.data);
    })
  },
  methods: {
    ...mapActions({
      init: "legal_contract/init",
    }),
  },
  computed: {
    ...mapFields('legal_contract', ['content', 'loading']),
  },
};
</script>

<style scoped>
.subtitle {
  font-size: small;
}

::v-deep table {
  border: 1px solid black;
  border-collapse: collapse;
  margin: 0;
  padding: 0;
  width: 100%;
  table-layout: fixed;
  text-align: center;
  pointer-events: none;
}

::v-deep table tr {
  border: 1px solid black;
  padding: .35em;
}

::v-deep table th,
::v-deep table td {
  padding: .625em;
  border: 1px solid black;
}

::v-deep table th {
  font-size: .85em;
  letter-spacing: .1em;
  text-transform: uppercase;
}
</style>
